import { useQuery } from "@tanstack/react-query";
import { ShieldCheck, FlaskConical } from "lucide-react";
import { Skel } from "@/components/app/Common";
import { get } from "@/lib/api";

export default function AssessmentTemplates() {
  const { data, isLoading } = useQuery({ queryKey: ["assessment-templates"], queryFn: () => get("/assessment-templates") });
  if (isLoading) return <Skel className="h-64" />;
  return (
    <div className="space-y-4" data-tour="pt-assessment-templates-page" data-testid="assessment-templates-page">
      {data.map((t) => (
        <section key={t.key} className="panel space-y-2 p-6" data-testid={`assessment-template-${t.key}`}>
          <div className="flex flex-wrap items-center gap-2">
            {t.hiring_safe ? <ShieldCheck size={16} className="text-success" aria-hidden="true" /> : <FlaskConical size={16} className="text-caution" aria-hidden="true" />}
            <h2 className="text-base font-semibold">{t.name}</h2>
            {t.default && <span className="rounded-full bg-brand-tint px-2 py-0.5 text-xs font-medium text-brand">Default</span>}
            <span className="text-xs text-ink-muted">{t.item_count} items · about {t.est_minutes} min</span>
          </div>
          {t.note && <p className="text-sm font-medium text-ink" data-tour="pt-hiring-safe-note" data-testid="hiring-safe-note">{t.note}.</p>}
          {t.removed_items.length > 0 && <p className="text-sm text-ink-secondary">Removed: {t.removed_items.map((r) => `“${r}”`).join(", ")}. Liberalism (O6) had fewer than 2 items left, so it is dropped and Openness is scored from the other 5 facets with re-derived norms.</p>}
          {!t.hiring_safe && t.key !== "ipip_50" && <p className="text-sm text-caution">Contains political and religious statements. Only choose this for research, never as a hiring default.</p>}
        </section>
      ))}
    </div>
  );
}
